import React from 'react';
import './cities.css';
import { connect } from 'react-redux';
import { updateCityFilter, updateSelectedCity } from '../../../actions/adminActions/citiesActions';
import { cities } from '../../../apis/backend'; //make sure to include this for each page
import EditCityModal from './cityModals/editCityModal.jsx';
import AddCityModal from './cityModals/addCityModal.jsx';

class Cities extends React.Component {
  async cityDeleteRequest(id) {
    await cities
      .delete(`/${id}`, {
        headers: { authorization: this.props.employeeToken }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  rendercities() {
    //renders the cities table
    return (
      <>
        {this.props.cities
          .filter((city) => {
            const filterString = `${city.name}`;
            return filterString.toLowerCase().indexOf(this.props.cityFilter.toLowerCase()) > -1;
          })
          .map((city) => (
            <tr key={this.props.cities.indexOf(city)}>
              <td className="text-center" style={{ width: '24%' }}>
                {`${city.name}`}
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                <div
                  data-target="#exampleModal"
                  className="btn btn-sm btn-dark"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedCity(city.id);
                  }}
                >
                  Edit
                </div>
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                <div
                  className="btn btn-sm btn-dark"
                  data-target="#deleteModal"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedCity(city.id);
                  }}
                >
                  Remove
                </div>
              </td>
            </tr>
          ))}
      </>
    );
  }

  getCityName() {
    const city = this.props.cities.find((obj) => obj.id === this.props.selectedCity);

    return city ? city.name : '';
  }

  render() {
    return (
      <div className="cities-page">
        <div className="container">
          <div
            className="form-inline md-form form-sm mt-4"
            style={{ fontSize: '36px', color: '#fff' }}
          >
            <div style={{ margin: 'auto', height: '48px', width: '100%' }}>Cities</div>
          </div>
          <div className="form-inline md-form form-sm mt-3">
            <input
              value={this.props.cityFilter}
              className="form-control form-control-lg w-45"
              type="text"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => {
                this.props.updateCityFilter(e.target.value);
              }}
            />
            <div
              data-target="#addModal"
              className="btn btn-lg btn-dark permission-super-admin "
              data-toggle="modal"
              style={{ marginLeft: '10px' }}
            >
              Add City
            </div>
          </div>
          <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table className="table table-striped  table-bordered table-hover bg-white mt-1 mr-3">
              <thead className="bg-dark thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '24%' }}>
                    Name
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Edit
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Remove
                  </th>
                </tr>
              </thead>
              <tbody>{this.rendercities()}</tbody>
            </table>
          </div>
        </div>

        <AddCityModal />
        <EditCityModal />

        <div className="modal fade" id="deleteModal" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ width: '80%', margin: '0 auto' }}>
              <div className="modal-header">
                <h5 className="modal-title">Are you Sure?</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.props.updateSelectedCity(0);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ textAlign: 'center', fontSize: '18px' }}>
                <strong>&apos;{this.getCityName()}&apos;</strong> will be deleted forever!!
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.cityDeleteRequest(this.props.selectedCity);
                    this.props.updateSelectedCity(0);
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.updateSelectedCity(0);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cities: state.admin.admin.cities,
  cityFilter: state.admin.cities.cityFilter,
  selectedCity: state.admin.cities.selectedCity,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {
  updateCityFilter,
  updateSelectedCity
})(Cities);
